var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg404Night(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 160,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188 104.696v-17.64l37.485-51.02h20.916v54.277h14.804v14.383h-14.804v19.269h-16.026v-19.269H188zm42.375-14.383V52.454l-27.707 37.859h27.707zM285.516 80c0 11.127 2.038 19.676 6.248 25.103 2.988 3.935 7.198 6.514 13.582 6.514 6.383 0 10.457-2.579 13.581-6.514 4.21-5.427 6.112-13.976 6.112-25.103s-1.901-19.676-6.112-25.103c-3.124-3.935-7.198-6.514-13.581-6.514-6.384 0-10.594 2.579-13.582 6.514-4.346 5.427-6.248 13.976-6.248 25.103zm-16.162 0c0-11.67 1.902-22.66 7.878-31.617C282.936 39.835 292.172 34 305.346 34c13.174 0 22.273 5.835 27.978 14.383C339.3 57.34 341.2 68.33 341.2 80c0 11.67-1.901 22.66-7.877 31.617C327.619 120.165 318.52 126 305.346 126c-13.175 0-22.41-5.835-28.114-14.383-5.976-8.956-7.878-19.947-7.878-31.617zm82.44 24.696v-17.64l37.486-51.02h20.916v54.277H425v14.383h-14.804v19.269H394.17v-19.269h-42.375zm42.376-14.383V52.454l-27.707 37.859h27.707z",
    stroke: "#44D9E9",
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "4,2"
  })));
}

export default Svg404Night;